import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://kwenfdhciqzpfrlpwqrj.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt3ZW5mZGhjaXF6cGZybHB3cXJqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzIyMTYwNzcsImV4cCI6MjA0Nzc5MjA3N30.ZHDRjkNqqeu_JLFiKoT9in7YuKXEU-kquzionus4I6c";
export const supabase = createClient(supabaseUrl, supabaseKey);
